"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
var _typeof2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
var _couponExpand = require("@/api/activity/couponExpand");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'couponEAct',
  components: {},
  props: {
    refresh: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    refresh: {
      immediate: true,
      handler: function handler(newId, oldId) {
        // 避免初始化时的不必要调用
        if (newId === oldId && oldId !== undefined) return;
        console.log('actId', newId);
        if (newId) {
          this.fetchList();
        }
      }
    }
  },
  emits: ['addAct', 'handleEdit', 'detailUser'],
  data: function data() {
    return {
      loading: false,
      times: [],
      searchForm: {
        startTime: '',
        endTime: '',
        keywords: '',
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: [],
      dialogVisible: false,
      searchForm2: {
        page: 1,
        limit: 10,
        total: 0,
        cardNo: '',
        mobile: '',
        status: ''
      },
      expandId: '',
      userList: []
    };
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 497, "px");
    }
  },
  methods: {
    dateFormat2: function dateFormat2(date, format) {
      var d = date instanceof Date ? date : new Date(date);
      if (isNaN(d.getTime())) return '';
      var map = {
        'yyyy': d.getFullYear(),
        'MM': ('0' + (d.getMonth() + 1)).slice(-2),
        'dd': ('0' + d.getDate()).slice(-2),
        'HH': ('0' + d.getHours()).slice(-2),
        'mm': ('0' + d.getMinutes()).slice(-2),
        'ss': ('0' + d.getSeconds()).slice(-2)
      };
      var fmt = format || 'yyyy-MM-dd HH:mm:ss';
      Object.keys(map).forEach(function (k) {
        fmt = fmt.replace(k, map[k]);
      });
      return fmt;
    },
    getUserList: function getUserList(e) {
      var _this = this;
      if (e) {
        this.expandId = e;
        this.searchForm2.expandId = e;
        this.searchForm2.page = 1;
      }
      this.dialogVisible = true;
      (0, _couponExpand.getInventoryList)(this.searchForm2).then(function (res) {
        res.records.forEach(function (item) {
          if (item.createDate) {
            item.createDate = _this.dateFormat2(item.createDate);
          }
        });
        _this.userList = res.records || [];
        _this.searchForm2.total = res.total || 0;
      });
    },
    addAct: function addAct() {
      this.$emit('addAct');
    },
    handleEdit: function handleEdit(row) {
      this.$emit('handleEdit', row);
    },
    handleCopy: function handleCopy(row) {
      this.$emit('handleCopy', row);
    },
    detailUser: function detailUser(row) {
      this.$emit('detailUser', row);
    },
    changeTime: function changeTime(e) {
      console.log(e);
      if (!e || e.length === 0) {
        // 清除筛选条件
        this.searchForm.startTime = '';
        this.searchForm.endTime = '';
        this.fetchList(); // 重新加载数据
      } else {
        this.searchForm.startTime = e[0];
        this.searchForm.endTime = e[1];
        console.log((0, _typeof2.default)(e[0]), e[0]);
      }
    },
    indexMethod: function indexMethod(index) {
      return (this.searchForm.page - 1) * this.searchForm.limit + index + 1;
    },
    handleSortChange: function handleSortChange(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      this.searchForm.sortField = prop;
      this.searchForm.sortOrder = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : '';
      this.fetchList();
    },
    pad: function pad(n) {
      return n.toString().padStart(2, '0');
    },
    fetchList: function fetchList() {
      var _this2 = this;
      this.loading = true;
      (0, _couponExpand.getActList)(this.searchForm).then(function (res) {
        res.records.forEach(function (item) {
          // 1长期 0快闪
          if (item.begType == 0) {
            var date = new Date(item.begDate);
            var date2 = new Date(item.endDate);
            var year = date.getFullYear();
            var month = _this2.pad(date.getMonth() + 1);
            var day = _this2.pad(date.getDate());
            var hours = _this2.pad(date.getHours());
            var mins = _this2.pad(date.getMinutes());
            var secs = _this2.pad(date.getSeconds());
            item.begDate = "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(mins, ":").concat(secs);
            var year2 = date2.getFullYear();
            var month2 = _this2.pad(date2.getMonth() + 1);
            var day2 = _this2.pad(date2.getDate());
            var hours2 = _this2.pad(date2.getHours());
            var mins2 = _this2.pad(date2.getMinutes());
            var secs2 = _this2.pad(date2.getSeconds());
            item.endDate = "".concat(year2, "-").concat(month2, "-").concat(day2, " ").concat(hours2, ":").concat(mins2, ":").concat(secs2);
            item.actTime = "".concat(item.begDate, " ~ ").concat(item.endDate);
          } else {
            item.actTime = '长期';
            // item.endDate = '长期';
          }
        });
        _this2.tableData = res.records || [];
        _this2.searchForm.total = res.total || 0;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    // 每页条数变化
    handleSizeChange: function handleSizeChange(newSize) {
      this.searchForm.limit = newSize;
      this.searchForm.page = 1;
      this.fetchList();
    },
    // 页码变化
    handlePageChange: function handlePageChange(newPage) {
      this.searchForm.page = newPage;
      this.fetchList();
    },
    handlePageChange2: function handlePageChange2(newPage) {
      this.searchForm2.page = newPage;
      this.getUserList();
    },
    handleSizeChange2: function handleSizeChange2(newSize) {
      this.searchForm2.limit = newSize;
      this.searchForm2.page = 1;
      this.getUserList();
    }
  },
  mounted: function mounted() {
    this.fetchList();
  }
};